import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  Typography,
  Form,
  Row,
  Col,
  Modal,
  Space,
  Pagination,
  message,
  Dropdown,
  List,
} from "antd";

import moment from "moment";
import {
  faArrowRightToBracket,
  faArrowRightFromBracket,
  faCloudDownload,
  faTrash,
  faEye,
  faPen,
  faFilter,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListAssetsFilters from "./ListAssetsFilters";
import EditAssetModal from "./EditAssetModal";
import AssetCheckInOutModal from "./AssetCheckInOutModal";
import {
  handleUpdateAttachment,
} from "../../../blueplanitUtils/attachments";
import { S3ACCESSURL } from "../../../databucket";
import { useDispatch } from "react-redux";
import { AntdButton, } from "../../../blueplanitUtils/InputField";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import AssetWorkHistory from "./AssetWorkHistory";
import AddAsset from "./AddAsset";
import { handleExport as assetExport } from "./AssetCheckInOutModal";
import {
  getAllAssets,
  checkoutAsset,
  updateAsset,
  softDeleteAsset
} from "../../../Slices/assetSlice";
import dayjs from "dayjs";
const { Title } = Typography;

const ListAssets = () => {
  const [filterForm] = Form.useForm();
  const [editForm] = Form.useForm();
  const dispatch = useDispatch();
  const [showAddModal, setShowAddModal] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [totalAssets, setTotalAssets] = useState(0);
  const [assetList, setAssetList] = useState([]);
  const [filters, setFilters] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const AllAssets = useSelector((state) => state.Assets.allAssets);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [AttachmentHistory, setAttachmentHistory] = useState([]);
  const [Changedattachment, setChangedAttachment] = useState([]);
  const [currentAttachments, setCurrentAttachments] = useState([]);
  const fileInputEditRef = useRef(null);
  const details = useSelector((state) => state.employee.AllEmployees);
  const loginUser = useSelector(
    (state) => state?.loginUserInfo?.loginUserDetails
  );
  const options = useSelector((state) => state.dataBucket.databucket);
  const usersList = useSelector((state) => state.employee.AllEmployees);
  const assignToUsers = usersList.filter(
    (user) => user.employeestatus === "Active"
  );

  const id = loginUser.id;
  const [isCheckOutModalOpen, setIsCheckOutModalOpen] = useState(false);
  const [selectedAssetForCheckout, setSelectedAssetForCheckout] = useState(null);
  const [checkoutForm] = Form.useForm();

  useEffect(() => {
    if (AllAssets) {
      const activeAssets = AllAssets?.records
        ?.filter((asset) => asset?.status !== false)
        ?.map((asset) => ({
          ...asset,
          id: asset.id || asset._id || null,
          purchaseDate: asset.purchaseDate,
          checkInStatus: asset.checkInStatus === false ? false : true,
          updateHistory: (asset.updateHistory || []).map((history) => {
            let editedAt = null;

            if (history.editedAt) {
              // Try parse as number
              const num = Number(history.editedAt);
              if (!isNaN(num)) {
                editedAt = num < 1e12 ? moment(num * 1000) : moment(num);
              } else {
                editedAt = moment(history.editedAt);
              }
              if (!editedAt.isValid()) editedAt = null;
            }

            return {
              ...history,
              editedAt: editedAt ? editedAt.toISOString() : null, // store as ISO string
            };
          }),

        }));
      setAssetList(activeAssets);
      setTotalAssets(AllAssets.totalCount || 0);
    }
  }, [AllAssets]);

  const openEditModal = (asset) => {
    setAttachmentHistory(
      asset?.attachments?.map((attachment) => ({
        ...attachment,
        emailId: attachment.id,
      }))
    );
    setSelectedAsset(asset);
    setIsEditModalOpen(true);
    editForm.setFieldsValue({
      ...asset,
      purchaseDate: asset.purchaseDate
        ? dayjs(Number(asset.purchaseDate))
        : null,
    });
  };

  const closeViewModal = () => {
    setSelectedAsset(null);
    setIsViewModalOpen(false);
  };

  const handleSearch = (values) => {
    const filteredValues = Object.fromEntries(
      Object.entries(values).filter(([_, v]) => v !== undefined && v !== "")
    );

    // Check if any filter is selected
    if (
      Object.keys(filteredValues).length === 0 ||
      (
        !filteredValues.purchaseDateFrom &&
        !filteredValues.purchaseDateTo &&
        Object.keys(filteredValues).length === 0
      )
    ) {
      message.error("Please select at least one filter");
      return;
    }
    const updatedFilters = {
      ...Object.fromEntries(
        Object.entries(values).filter(([_, v]) => v !== undefined && v !== "")
      ),
      purchaseDateFrom: values.purchaseDateFrom
        ? dayjs(values.purchaseDateFrom).startOf("day").valueOf().toString()
        : undefined,
      purchaseDateTo: values.purchaseDateTo
        ? dayjs(values.purchaseDateTo).endOf("day").valueOf().toString()
        : undefined,
    };

    dispatch(
      getAllAssets({
        page: 1,
        pageSize: 10,
        ...updatedFilters,
      })
    );

    setFilters(updatedFilters);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  useEffect(() => {
    dispatch(
      getAllAssets({
        page: pagination.current,
        pageSize: pagination.pageSize,
        ...filters,
      })
    );
  }, [filters, pagination.current]);

  const handleClear = () => {
    filterForm.resetFields();
    setFilters({});
    dispatch(getAllAssets({ page: 1, pageSize: pagination.pageSize }));
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: "Are you sure you want to delete this asset?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        try {
          const editedAt = new Date().toISOString();
          const userName = `${loginUser?.firstname} ${loginUser?.lastname}`;

          const resultAction = await dispatch(
            softDeleteAsset({ id, userName, editedAt })
          );

          if (softDeleteAsset.fulfilled.match(resultAction)) {
            message.success("Asset deleted successfully!");
          } else {
            message.error("Deletion failed!");
          }
        } catch (err) {
          message.error("Failed to delete asset");
        }
      },
    });
  };

  const exportColumns = [
    "sno",
    "assetTagId",
    "purchasedFrom",
    "purchaseDate",
    "cost",
    "brand",
    "model",
    "category",
    "department",
    "createdBy",
    "description",
  ];


  const showAttachmentsModal = (attachments, row) => {
    setAttachmentHistory(attachments);
    setSelectedAsset(row);
    setIsModalVisible2(true);
  };



  const handleReplaceAttachment = async (file, file2, idx) => {
    const replaced = await handleUpdateAttachment(
      file,
      file2,
      selectedAsset?.id,
      dispatch,
      details,
      id
    );
    setAttachmentHistory((prev) =>
      prev.map((item) => (item.id === replaced?.emailId ? replaced : item))
    );
    setChangedAttachment((prev) => [...prev, replaced]);
  };
  const handleDeleteAtta = async (file, index) => {
    try {
      let updatedItem = null;

      if (file?.id) {
        setAttachmentHistory((prev) => {
          const updated = prev.map((item) => {
            if (item.id === file.id) {
              updatedItem = {
                ...item,
                status: false,
                deleteDate: Date.now().toString(),
              };
              return updatedItem;
            }
            return item;
          });
          return updated;
        });
      } else {
        setAttachmentHistory((prev) =>
          prev.filter((item, i) => item.url !== file?.url)
        );
        setCurrentAttachments((prev) =>
          prev.filter((item, i) => item.url !== file?.url)
        );
      }
      if (updatedItem) {
        setChangedAttachment((prev) => [...prev, updatedItem]);
      }

      message.success("Attachment deleted successfully");
    } catch (error) {
      message.error("Failed to delete attachment");
    }
  };

  const handleNewAttachmentsUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const formattedFiles = files.map((file) => ({
      file,
      filename: file.name,
      url: URL.createObjectURL(file),
      type: file.type,
      status: true,
    }));
    setCurrentAttachments(formattedFiles);
    setAttachmentHistory((prev) => [...prev, ...formattedFiles]);
    message.success("New attachments added!");
  };

  const handleModalClose = () => {
    setIsModalVisible2(false);
  };
  const columns = [
    {
      title: "S.No",
      key: "sno",
      align: "center",
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Purchase Date",
      dataIndex: "purchaseDate",
      align: "center",
      render: (date) => dayjs(parseInt(date)).format("DD/MM/YYYY"),
    },
    { title: "Asset Tag ID", dataIndex: "assetTagId", align: "center" },
    { title: "Product Name", dataIndex: "productName", align: "center" },
    { title: "Purchased From", dataIndex: "purchasedFrom", align: "center" },
    {
      title: "Cost",
      dataIndex: "cost",
      align: "center",
      render: (value) => (value ? `₹ ${value}` : ""),
    },
    { title: "Brand", dataIndex: "brand", align: "center" },
    { title: "Model", dataIndex: "model", align: "center" },
    { title: "Category", dataIndex: "category", align: "center" },
    { title: "Department", dataIndex: "department", align: "center" },
    {
      title: "Attachments",
      dataIndex: "attachments",
      key: "attachments",
      align: "center",
      width: 200,
      render: (attachments, row) => {
        const activeAttachments = attachments?.filter(
          (att) => att.status === true
        );
        if (!activeAttachments || activeAttachments.length === 0)
          return "No Attachments";

        return (
          <AntdButton label='View' onClick={() => showAttachmentsModal(activeAttachments, row)} />
        );
      },
    },
    { title: "Created By", dataIndex: "createdBy", align: "center" },
    { title: "Description", dataIndex: "description", align: "center" },
    {
      title: "Check In",
      key: "checkIn",
      align: "center",
      render: (_, record) => (
        <AntdButton
          type="primary"
          size="small"
          disabled={!record.checkInStatus}
          style={{
            backgroundColor: record.checkInStatus ? "#1890ff" : "#f5f5f5",
            color: record.checkInStatus ? "#fff" : "#999",
            borderColor: record.checkInStatus ? "#1890ff" : "#d9d9d9",
            cursor: record.checkInStatus ? "pointer" : "not-allowed",
            boxShadow: "none",
          }}
          icon={<FontAwesomeIcon icon={faArrowRightToBracket} />}

        />
      ),
    },
    {
      title: "Check Out",
      key: "checkOut",
      align: "center",
      render: (_, record) => (
        <AntdButton
          type={record.checkInStatus ? "default" : "primary"}
          size="small"
          onClick={() => {
            checkoutForm.resetFields();
            setSelectedAssetForCheckout(record);
            setIsCheckOutModalOpen(true);

            // Extracting previous values if any
            const prevCheckedOutBy =
              record?.checkedOutBy ||
              `${loginUser?.firstname} ${loginUser?.lastname}`;
            const prevCheckOutDate = record?.checkOutDate
              ? dayjs(Number(record.checkOutDate))
              : dayjs();
            const prevExpectedCheckInDate = record?.expectedCheckInDate
              ? dayjs(Number(record.expectedCheckInDate))
              : null;
            const prevCheckOutReason = record?.checkOutReason || "";

            checkoutForm.setFieldsValue({
              checkedOutBy: prevCheckedOutBy,
              checkOutDate: prevCheckOutDate,
              expectedCheckInDate: prevExpectedCheckInDate,
              checkOutReason: prevCheckOutReason,
            });
          }}
          style={{
            backgroundColor: !record.checkInStatus ? "#1890ff" : "#f5f5f5",
            color: !record.checkInStatus ? "#fff" : "#000",
            borderColor: !record.checkInStatus ? "#1890ff" : "#d9d9d9",
            boxShadow: "none",
          }}
          icon={<FontAwesomeIcon icon={faArrowRightFromBracket} />}
        />
      ),
    },

    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <FontAwesomeIcon
            icon={faEye}
            style={{ fontSize: 14, color: "#000", cursor: "pointer" }}
            onClick={() => {
              setSelectedAsset(record);
              setIsViewModalOpen(true);
            }}
          />
          <FontAwesomeIcon
            icon={faPen}
            style={{ fontSize: 14, color: "#1890ff", cursor: "pointer" }}
            onClick={() => openEditModal(record)}
          />
          <FontAwesomeIcon
            icon={faTrash}
            style={{ fontSize: 14, color: "#ff4d4f", cursor: "pointer" }}
            onClick={() => handleDelete(record.id)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 26, marginTop: 25 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginBottom: 6,
          position: "relative",
          zIndex: 10,
        }}
      >
        <AntdButton
          type="primary"
          label="Add Asset"
          onClick={() => setShowAddModal(true)}
        />
        <AntdButton
          type="primary"
          label="Filters"
          onClick={() => setShowFilters((prev) => !prev)}
          icon={<FontAwesomeIcon icon={faFilter} />}
        />
        <Dropdown
          menu={{
            items: [
              { key: "CSV", label: "Export as CSV" },
              { key: "PDF", label: "Export as PDF" },
            ],
            onClick: ({ key }) =>
              assetExport(key, exportColumns, assetList, pagination),
          }}
          trigger={["click"]}
        >
          <AntdButton
            type="primary"
            label="Export"
            icon={<FontAwesomeIcon icon={faCloudDownload} />}
          />
        </Dropdown>
      </div>

      <Row
        gutter={60}
        style={{ minHeight: "100%", marginTop: '-25px' }}
      >
        {showFilters && (
          <ListAssetsFilters
            filterForm={filterForm}
            handleSearch={handleSearch}
            handleClear={handleClear}
            options={options}
            assignToUsers={assignToUsers}
            setShowFilters={setShowFilters}
          />
        )}

        <Col
          span={24}
          style={{
            marginLeft: showFilters ? 250 : 0,
            transition: 'margin-left 0.3s ease',
            maxHeight: "none",
            minHeight: "100vh",
            overflow: "visible"
          }}
        >

          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Title level={3} style={{ marginBottom: 16 }}>
              List of Assets
            </Title>

            <div
              style={{
                overflowX: "hidden",
                paddingRight: 8,
              }}
            >
              <CustomGridTable
                columns={columns}
                Id="list-assets-table"
                scroll={{ x: "max-content" }}
                dataSource={assetList?.map((item, index) => ({
                  ...item,
                  key: item.id || index,
                }))}
                pagination={false}
                bordered
                size="small"
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 12,
              }}
            >
              <Pagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={totalAssets}
                onChange={(page) => {
                  setPagination((prev) => ({ ...prev, current: page }));
                }}
                showSizeChanger={false}
                size="small"
              />
            </div>
          </div>
        </Col>

      </Row>

      <EditAssetModal
        isEditModalOpen={isEditModalOpen}
        setIsEditModalOpen={setIsEditModalOpen}
        selectedAsset={selectedAsset}
        editForm={editForm}
        AllAssets={AllAssets}
        options={options}
        AttachmentHistory={AttachmentHistory}
        setAttachmentHistory={setAttachmentHistory}
        Changedattachment={Changedattachment}
        setChangedAttachment={setChangedAttachment}
        currentAttachments={currentAttachments}
        setCurrentAttachments={setCurrentAttachments}
        fileInputEditRef={fileInputEditRef}
        handleNewAttachmentsUpload={handleNewAttachmentsUpload}
        handleReplaceAttachment={handleReplaceAttachment}
        handleDeleteAtta={handleDeleteAtta}
        updateAsset={updateAsset}
        loginUser={loginUser}
        details={details}
        dispatch={dispatch}
        id={id}
        message={message}
        getAllAssets={getAllAssets}
        pagination={pagination}
        filters={filters}
        setSelectedAsset={setSelectedAsset}
        setAssetList={setAssetList}
      />

      <AssetWorkHistory
        open={isViewModalOpen}
        onClose={closeViewModal}
        selectedAsset={selectedAsset}
      />
      <Modal
        open={showAddModal}
        onCancel={() => setShowAddModal(false)}
        footer={null}
        width={750}
        destroyOnClose
      >
        <AddAsset
          onClose={() => setShowAddModal(false)}
          onSuccess={() => {
            setSelectedAsset(null);
            setIsEditModalOpen(false);
          }}
        />
      </Modal>
      <AssetCheckInOutModal
        isCheckOutModalOpen={isCheckOutModalOpen}
        setIsCheckOutModalOpen={setIsCheckOutModalOpen}
        selectedAssetForCheckout={selectedAssetForCheckout}
        checkoutForm={checkoutForm}
        loginUser={loginUser}
        dispatch={dispatch}
        checkoutAsset={checkoutAsset}
        AllAssets={AllAssets}
        getAllAssets={getAllAssets}
        pagination={pagination}
        filters={filters}
        message={message}
      />
      <Modal
        title="Attachments"
        open={isModalVisible2}
        onCancel={handleModalClose}
        footer={null}
      >
        <List
          dataSource={AttachmentHistory.filter((file) => file.status === true)}
          renderItem={(file, idx) => (
            <List.Item key={idx}>
              <a
                href={
                  file?.url?.startsWith("http")
                    ? file.url
                    : `${S3ACCESSURL}${file.url || file.data}`
                }
                target="_blank"
                rel="noopener noreferrer"
                style={{ flex: 1, textAlign: "left" }}
              >
                {file?.filename || `File ${idx + 1}`}
              </a>

            </List.Item>
          )}
        />
      </Modal>
    </div>
  );
};
export default ListAssets;
